import { BackendResponse } from "../BackendResponse";

export interface GetCurrentApplicationItemResponse extends BackendResponse {
  idRelated?: number;
  typeRelated?: number;
}

export interface GetCurrentApplicationItemParameters {
  idConcern: number;
}

export type getCurrentApplicationItem = (
  args: GetCurrentApplicationItemParameters
) => Promise<GetCurrentApplicationItemResponse>;

export const getCurrentApplicationItem: getCurrentApplicationItem = null;
